import { cva } from 'class-variance-authority';
import { cn } from '@/shared/lib/utils';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  color?: 'base' | 'primary' | 'secondary';
};

export const skeletonVariants = cva('', {
  variants: {
    color: {
      base: 'bg-surface-strength1',
      secondary: 'bg-surface-strength2',
      primary: 'bg-gradient-to-r from-[#E9F4F0]/30 from-2.34% to-[#D2E9E0]/30 to-99.64%',
    },
  },
  defaultVariants: {
    color: 'base',
  },
});

export const Skeleton = ({ className, color = 'base', ...props }: Props) => {
  return (
    <div
      className={cn('animate-pulse rounded-md', skeletonVariants({ color }), className)}
      {...props}
    />
  );
};
